import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import alcatel from "../partners/images/alcatel.png"
import hikvision from "../partners/images/hikvision.png"
import salto from "../partners/images/salto.jpg"
import lda from "../partners/images/lda.png"
import igloo from "../partners/images/igloo.svg"
import dahua from "../partners/images/dahua.png"
import gsn from "../partners/images/gsn.png"
import bolid from "../partners/images/bolid.jpg"

const Carousel = () => {
    return (
        <Swiper slidesPerView={4} spaceBetween={30} loop={true} pagination={{clickable: true,}} 
            navigation={true} modules={[Navigation]}
        >

            <SwiperSlide>
                <div className="swiper-slide">
                    <img src={salto} alt=""/>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className="swiper-slide">
                    <img src={hikvision} alt=""/>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className="swiper-slide">
                    <img src={igloo} alt=""/>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className="swiper-slide">
                    <img src={lda} alt=""/>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className="swiper-slide">
                    <img src={dahua} alt=""/>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className="swiper-slide">
                    <img src={gsn} alt=""/>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className="swiper-slide">
                    <img src={bolid} alt=""/>
                </div>
            </SwiperSlide>
        </Swiper>

    
    );
}
 
export default Carousel;